import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { PlayerSearchResultAvatar } from "./PlayerSearchResultAvatar";
export const PlayerSearchResultView = ({ playerSearchResult, variant = "h6", }) => {
    return (_jsxs(Stack, { direction: "row", spacing: 2, alignItems: "center", children: [_jsx(PlayerSearchResultAvatar, { playerSearchResult: playerSearchResult }), _jsx(Typography, { variant: variant, children: _jsx(PlayerSearchResultDisplayNameLink, { playerSearchResult: playerSearchResult }) })] }));
};
const PlayerSearchResultDisplayNameLink = ({ playerSearchResult, }) => {
    const displayName = `${playerSearchResult?.firstName} ${playerSearchResult?.lastName}`;
    return (_jsx(Link, { style: { textDecoration: "none" }, to: `/players/${playerSearchResult.id}/`, children: displayName }, playerSearchResult.id));
};
